export default __webpack_public_path__ + "static/media/env4.9e4de0a2.hdr";